import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { AppPreloadingStrategy } from './core/preloading-strategy/preloading-strategy';
import { ForgotPasswordComponent } from './modules/auth/components/forgot-password/forgot-password.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'flight',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'hotels',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'activity',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'transfers',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'holiday',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'supplier',
    loadChildren: () => import('./modules/supplier/supplier.module').then(m => m.SupplierModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./modules/faq/faq.module').then(m => m.FaqModule)
  },
  {
    path: 'cms',
    loadChildren: () => import('./modules/dummy/dummy.module').then(m => m.DummyModule)
  },
  {
    path: 'city-details',
    loadChildren: () => import('./modules/city-details/city-details.module').then(m => m.CityDetailsModule)
  },
  {
    path: 'flights',
    loadChildren: () => import('./modules/flights/flights.module').then(m => m.FlightsModule)
  },
  {
    path: 'user-management',
    loadChildren: () => import('./modules/user-management/user-management.module').then(m => m.UserManagementModule)
  },
  {
    path:'auth/forgot-password',
    component: ForgotPasswordComponent, 
    data: { extraParameter: '' }
  },
  {
    path: "payment",
    loadChildren: () =>
      import("./modules/payment/payment.module").then((m) => m.PaymentModule),
  },
  
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled', // Restores scroll position to the top
  onSameUrlNavigation: 'reload', // Forces route to reload even if it's the same URL
  preloadingStrategy: AppPreloadingStrategy,
  useHash:false
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})

export class AppRoutingModule { }